export enum BannerLocation {
    HOME = 'HOME',
    ALL = 'ALL'
}

export type Banner = {
    id: number
    name: string
    value: string
    location: BannerLocation
    priority: number
}

export type BannerCreateInput = {
    name: string
    value: string
    location: BannerLocation
}

export type BannerUpdateInput = {
    id: number
    name: string
    value: string
    location: BannerLocation
}